var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar--header"},[_c('img',{attrs:{"src":_vm.developer_image,"alt":_vm.name}}),_c('div',{staticClass:"developer--name text-center my-3"},[_c('a',{attrs:{"href":_vm.developer_web,"target":"_blank"}},[_c('strong',[_vm._v(_vm._s(_vm.name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }